import React from 'react';

import SectionBreakTitle, { SectionColor } from '@components/SectionBreakTitle';
import Spinner from '@components/Spinner';
import {
  useCurrentUser,
  useGiftSubscriptionSettings,
  useGroupSubscriptionsRecipients,
} from '@hooks';
import { GROUP_SUBSCRIPTION_GIFT } from '@src/constants';

import SubscriptionOverview from '../GroupSubscription/SubscriptionOverview';
import SettingHeaderSeperator from '../SettingHeaderSeperator';
import GiftForm from './GiftForm';
import styles from './styles.module.scss';

const Gift = () => {
  const { data: recipients, isLoading } = useGroupSubscriptionsRecipients(GROUP_SUBSCRIPTION_GIFT);
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const { giftSubscriptionSetting, isGiftSettingsLoading } = useGiftSubscriptionSettings();
  const canAccessGiftSubscription = currentUser?.settings_access_obj?.gift_sub_access;

  return (
    <>
      {isLoading || isLoadingCurrentUser || isGiftSettingsLoading ? (
        <Spinner />
      ) : (
        <>
          <SectionBreakTitle
            className="mb-32"
            titleClassName="text-primary-magenta"
            color={SectionColor.Magenta}
            title="Gift subscriptions"
          />
          <div className={styles.giftSubHeader} id="GiftSubHeader">
            {canAccessGiftSubscription ? (
              <>
                You can give others access to The Information. Share as a gift or with your team—add
                additional subscribers for ${giftSubscriptionSetting?.offer?.initialPrice} a year
                per person.
              </>
            ) : (
              <>
                You can give others access to The Information. Share as a gift or with your team.
                You do not currently have access to this program, but if you would like to get
                access email{' '}
                <a
                  className="!text-primary-magenta hover:opacity-80"
                  href="mailto:support@theinformation.com"
                >
                  support@theinformation.com
                </a>
              </>
            )}
          </div>
          {canAccessGiftSubscription && (
            <>
              <div className="mb-48">
                <GiftForm />
              </div>

              <SettingHeaderSeperator sectionName="Subscriptions" />
              <div className={styles.giftSubHeader} id="GiftSubHeader">
                You are currently supporting the following subscriptions for others to The
                Information
              </div>
              <SubscriptionOverview
                recipients={recipients}
                groupSubscriptionType={GROUP_SUBSCRIPTION_GIFT}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default Gift;
